
var decode = require('iconv-lite').decode;

export function fetchDecode(url, message){
    return fetch(url,
        {
            headers: new Headers({
                'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                'username': `${sessionStorage.getItem('username')}`
            })
        })
        .then(handleErrors)
        .then(response => response.json())
        .catch(function(error){
            console.log(error);
        });
}

function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}


// WEBPACK FOOTER //
// ./src/fetchUtils.js